// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__snfXN","content":"styles_content__PpxeJ","text_wrapper":"styles_text_wrapper__g566W"};